/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CREATE_USERS } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface InviteUserProps {
  email: string;
  firstName?: string;
  lastName?: string;
  invite?: boolean;
  role?: string;
}
export interface IInviteUserMethods extends IPluginMethodMap {
  getInviteUser(args: InviteUserProps): Promise<any>;
}

export class InviteUserService implements IAgentPlugin {
  readonly methods: IInviteUserMethods;

  constructor() {
    this.methods = {
      getInviteUser: this.getInviteUser.bind(this),
    };
  }

  async getInviteUser(args: InviteUserProps) {
    log.blue(`inviteUser server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        log.blue(`inviteUser server component222:`, args);
        const res = await client.mutate({
          mutation: CREATE_USERS,
          variables: {
            input: {
              invite: true,
              role: "99403c8b-abc1-4796-b61f-78e0c4022792",
              user: {
                email: args?.email,
                firstName: args?.firstName,
                lastName: args?.lastName,
              },
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.createUser,
          };
        }
      }
    } catch (err: any) {
      console.log("error-->", err);
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
